// Met à jour le sélecteur "Changer l'affichage" (rendu dans les filtres ordinateur et mobile)
function update_display_toggle(show_vrac) {
  document.querySelectorAll("[data-display-toggle]").forEach(function (button) {
    var active = (button.dataset.displayToggle === "vrac") === show_vrac;
    button.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

// Affiche les images vrac (true) ou sachet (false)
function set_secondary_image(show_vrac) {
  var showing_vrac = document.getElementsByClassName("show_secondary").length > 0;
  if (showing_vrac !== show_vrac) {
    toogle_secondary_image();
  }
  update_display_toggle(show_vrac);
}


function toogle_secondary_image() {
  var has_secondary = document.getElementsByClassName("product-item__image--vrac");
  var show_secondary = document.getElementsByClassName("show_secondary").length;
  
  var show_secondary_date = new Date();
  show_secondary_date.setMonth(show_secondary_date.getMonth() + 12);
  
  if (show_secondary > 0) {
    
    document.cookie = "show_secondary=false; domain=www.jardins-hermitage.com; path=/; secure; expires=" + show_secondary_date.toUTCString() + "";
    Array.prototype.forEach.call(has_secondary, function(el) {
      el.classList.remove("show_secondary");
      update_display_toggle(false);
      });
  } else {
    document.cookie = "show_secondary=true; domain=www.jardins-hermitage.com; path=/; secure; expires=" + show_secondary_date.toUTCString() + "";
    Array.prototype.forEach.call(has_secondary, function(el) {
      el.classList.add("show_secondary");
      update_display_toggle(true);
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (document.cookie.split("; ").find((row)=> row.startsWith("show_secondary="))?.split('=')[1] == 'true') {
    var has_secondary = document.getElementsByClassName("product-item__image--vrac");
    Array.prototype.forEach.call(has_secondary, function(el) {
      el.classList.add("show_secondary");
      update_display_toggle(true);
    });
  }
});


document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    if (document.cookie.split("; ").find((row)=> row.startsWith("show_secondary="))?.split('=')[1] == 'true') {
    var has_secondary = document.getElementsByClassName("product-item__image--vrac");
    Array.prototype.forEach.call(has_secondary, function(el) {
      el.classList.add("show_secondary");
      update_display_toggle(true);
    });
  }
  }
}


